(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[54997,65250],{

/***/ 54997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TopCommercialCleanersWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/topcommercialcleaners/logo/index.tsx


function TopCommercialCleanersLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "392",
        height: "35",
        fill: "none",
        viewBox: "0 0 392 35",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_3)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#134981",
                        d: "M108.59 29.507a10.553 10.553 0 01-7.601-2.91 11.08 11.08 0 010-15.433 10.578 10.578 0 017.628-3.073 11.027 11.027 0 015.235 1.264 9.657 9.657 0 013.753 3.304l-2.04 1.7a8.152 8.152 0 00-6.798-3.576 7.668 7.668 0 00-5.63 2.311 7.903 7.903 0 00-2.311 5.82 7.655 7.655 0 007.913 7.914 8.279 8.279 0 003.889-.925 9.43 9.43 0 003.1-2.597l2.026 1.727a10.476 10.476 0 01-3.902 3.29 11.517 11.517 0 01-5.262 1.184zM127.504 29.561a7.714 7.714 0 01-5.711-2.27 7.893 7.893 0 01-2.23-5.67 7.692 7.692 0 012.23-5.603 7.58 7.58 0 015.711-2.298 7.504 7.504 0 015.656 2.298 7.78 7.78 0 012.258 5.602 7.869 7.869 0 01-2.258 5.67 7.627 7.627 0 01-5.656 2.271zm5.208-7.94a5.24 5.24 0 00-1.523-3.795 5.033 5.033 0 00-7.37 0 5.247 5.247 0 00-1.523 3.794 5.44 5.44 0 001.523 3.862 5.032 5.032 0 007.37 0 5.44 5.44 0 001.523-3.862zM156.086 13.72a5.738 5.738 0 014.392 1.768 6.583 6.583 0 011.632 4.732v8.974h-2.72V20.64a4.952 4.952 0 00-.965-3.263 3.295 3.295 0 00-2.72-1.156 3.716 3.716 0 00-2.896 1.237 4.584 4.584 0 00-1.129 3.236v8.499h-2.719v-8.499a5.004 5.004 0 00-.979-3.29 3.321 3.321 0 00-2.72-1.183 3.78 3.78 0 00-2.91 1.25 4.684 4.684 0 00-1.142 3.278v8.444h-2.719v-15.08h2.651v2.217a4.881 4.881 0 012.094-1.972 5.006 5.006 0 012.72-.653 5.644 5.644 0 012.842.735 4.45 4.45 0 011.89 2.08 5.34 5.34 0 012.243-2.067 7.016 7.016 0 013.155-.734zM183.498 13.72a5.711 5.711 0 014.392 1.768 6.579 6.579 0 011.632 4.732v8.974h-2.719V20.64a4.874 4.874 0 00-.979-3.263 3.27 3.27 0 00-2.652-1.156 3.74 3.74 0 00-2.91 1.237 4.64 4.64 0 00-1.115 3.236v8.499h-2.719v-8.499a4.921 4.921 0 00-.993-3.29 3.286 3.286 0 00-2.719-1.183 3.81 3.81 0 00-2.924 1.25 4.663 4.663 0 00-1.128 3.278v8.444h-2.72v-15.08h2.638v2.217a4.827 4.827 0 012.012-1.972 5.006 5.006 0 012.72-.653 5.673 5.673 0 012.842.735 4.519 4.519 0 011.89 2.08 5.439 5.439 0 012.23-2.067 7.055 7.055 0 013.222-.734zM207.512 21.375c0 .19 0 .64-.082 1.36h-12.02a4.905 4.905 0 005.289 4.31 8.872 8.872 0 002.788-.462 9.04 9.04 0 002.488-1.224l1.156 2.054a10.61 10.61 0 01-2.937 1.509 10.88 10.88 0 01-3.549.598 9.023 9.023 0 01-3.644-.68 6.315 6.315 0 01-2.516-1.822 8.637 8.637 0 01-1.36-2.529 8.997 8.997 0 01-.475-2.91c-.06-2.08.697-4.1 2.107-5.63a7.33 7.33 0 015.521-2.216 6.99 6.99 0 015.235 2.054 7.524 7.524 0 011.999 5.588zm-12.102-.965h9.314a4.32 4.32 0 00-2.804-3.998 4.327 4.327 0 00-1.697-.272 4.513 4.513 0 00-3.154 1.197 5.26 5.26 0 00-1.659 3.073zM213.399 29.194h-2.719v-15.08h2.57v2.217a4.513 4.513 0 014.337-2.611 7.732 7.732 0 011.768.217l-.258 2.625a5.024 5.024 0 00-1.564-.259 3.848 3.848 0 00-3.005 1.265 5.24 5.24 0 00-1.129 3.59v8.036zM227.989 29.534a7.773 7.773 0 01-5.751-2.217 8.333 8.333 0 010-11.354 7.993 7.993 0 015.86-2.216 8.163 8.163 0 014.08 1.06 6.64 6.64 0 012.719 2.87l-2.216 1.36a5.675 5.675 0 00-1.986-2.026 5.04 5.04 0 00-2.638-.735 5.254 5.254 0 00-3.861 1.55 5.754 5.754 0 000 7.737 4.935 4.935 0 003.753 1.55 5.438 5.438 0 002.719-.761 4.953 4.953 0 001.945-1.945l2.257 1.292a7.125 7.125 0 01-2.815 2.829 8.363 8.363 0 01-4.066 1.006zM239.221 11.966a1.945 1.945 0 01-1.36-.544 1.894 1.894 0 01-.557-1.36 1.8 1.8 0 01.557-1.36c.37-.343.856-.532 1.36-.53a1.822 1.822 0 011.36.544 1.788 1.788 0 01.571 1.36 1.857 1.857 0 01-.571 1.36 1.825 1.825 0 01-1.36.53zm1.36 2.148v15.08h-2.72v-15.08h2.72zM256.639 16.303v-2.189h2.598v15.08h-2.598v-2.135a6.477 6.477 0 01-5.316 2.502 7.001 7.001 0 01-5.439-2.312 8.08 8.08 0 01-2.149-5.71 7.607 7.607 0 012.149-5.576 7.156 7.156 0 015.439-2.216 6.554 6.554 0 015.316 2.556zm.177 5.317a5.441 5.441 0 00-1.441-3.82 4.79 4.79 0 00-3.739-1.578 4.708 4.708 0 00-3.699 1.577 5.956 5.956 0 000 7.71 4.751 4.751 0 003.712 1.577 4.828 4.828 0 003.74-1.577 5.438 5.438 0 001.427-3.889zM266.131 7.887v21.307h-2.72V7.887h2.72zM282.121 29.507a10.552 10.552 0 01-7.601-2.91 10.256 10.256 0 01-3.1-7.67 10.363 10.363 0 013.155-7.763 10.587 10.587 0 017.641-3.073 11.066 11.066 0 015.235 1.264 9.517 9.517 0 013.74 3.304l-2.081 1.7a8.152 8.152 0 00-6.798-3.576 7.668 7.668 0 00-5.63 2.311 7.838 7.838 0 00-2.311 5.82 7.638 7.638 0 002.228 5.685 7.632 7.632 0 005.685 2.229 8.231 8.231 0 003.876-.925 9.162 9.162 0 003.1-2.597l2.026 1.727a10.483 10.483 0 01-3.916 3.263 11.517 11.517 0 01-5.249 1.21zM296.766 7.887v21.307h-2.72V7.887h2.72zM314.973 21.375c0 .19 0 .64-.082 1.36h-12.02a4.91 4.91 0 005.289 4.31 8.864 8.864 0 002.72-.462 9.037 9.037 0 002.488-1.224l1.142 2.054a10.512 10.512 0 01-2.923 1.509 10.985 10.985 0 01-3.549.598 9.027 9.027 0 01-3.644-.68 6.316 6.316 0 01-2.516-1.822 8.61 8.61 0 01-1.359-2.529 8.971 8.971 0 01-.476-2.91c-.06-2.08.697-4.1 2.107-5.63a7.328 7.328 0 015.521-2.216 7.014 7.014 0 015.235 2.054 7.531 7.531 0 012.067 5.588zm-12.102-.965h9.314a4.324 4.324 0 00-4.5-4.27 4.514 4.514 0 00-3.155 1.197 5.26 5.26 0 00-1.659 3.073zM330.093 16.303v-2.189h2.597v15.08h-2.597v-2.135a6.5 6.5 0 01-5.316 2.502 7.035 7.035 0 01-5.439-2.312 8.063 8.063 0 01-2.135-5.71 7.58 7.58 0 012.135-5.576 7.18 7.18 0 015.439-2.216 6.577 6.577 0 015.316 2.556zm.177 5.317a5.441 5.441 0 00-1.441-3.82 4.784 4.784 0 00-3.74-1.578 4.716 4.716 0 00-3.725 1.577 6.01 6.01 0 000 7.71 4.76 4.76 0 003.725 1.577 4.828 4.828 0 003.74-1.577 5.524 5.524 0 001.441-3.889zM339.584 29.194h-2.719v-15.08h2.651v2.135a5.06 5.06 0 014.787-2.53 5.917 5.917 0 014.242 1.633 6.126 6.126 0 011.727 4.69v9.152h-2.72v-8.39a4.934 4.934 0 00-1.06-3.372 3.52 3.52 0 00-2.801-1.21 3.915 3.915 0 00-3.005 1.36 4.84 4.84 0 00-1.156 3.317l.054 8.295zM368.302 21.375c0 .19 0 .64-.081 1.36H356.2a4.91 4.91 0 005.29 4.31 9.519 9.519 0 005.262-1.686l1.156 2.054a10.71 10.71 0 01-2.924 1.509 11.049 11.049 0 01-3.548.598 9.031 9.031 0 01-3.645-.68 6.462 6.462 0 01-2.529-1.822 8.582 8.582 0 01-1.36-2.529 8.682 8.682 0 01-.489-2.91 7.914 7.914 0 012.121-5.63 7.32 7.32 0 015.521-2.216 7.037 7.037 0 015.18 2.067 7.569 7.569 0 012.067 5.575zM356.2 20.41h9.315a4.347 4.347 0 00-1.352-3.082 4.334 4.334 0 00-3.149-1.188 4.516 4.516 0 00-3.155 1.197 5.196 5.196 0 00-1.659 3.073zM374.19 29.194h-2.72v-15.08h2.557v2.217a4.513 4.513 0 014.337-2.611 7.841 7.841 0 011.782.217l-.259 2.625a5.099 5.099 0 00-1.577-.259 3.86 3.86 0 00-3.005 1.265 5.306 5.306 0 00-1.129 3.63l.014 7.996zM386.428 29.534a6.622 6.622 0 01-3.25-.843 5.928 5.928 0 01-2.352-2.42l1.944-1.496c.371.747.94 1.377 1.645 1.822a4.082 4.082 0 002.108.612 2.99 2.99 0 001.917-.599 1.84 1.84 0 00.748-1.482 2.153 2.153 0 00-1.36-1.917c-.244-.122-.87-.408-1.89-.843s-1.563-.68-1.863-.843a3.973 3.973 0 01-2.298-3.658 3.829 3.829 0 011.36-3.019 5.113 5.113 0 013.576-1.21c.942 0 1.872.214 2.72.626a4.84 4.84 0 012.026 1.767l-1.713 1.632a3.836 3.836 0 00-3.237-1.74 2.298 2.298 0 00-1.577.516 1.706 1.706 0 00-.598 1.36 1.887 1.887 0 001.264 1.768l1.659.734c.718.234 1.418.52 2.094.857a4.168 4.168 0 012.519 3.24 4.177 4.177 0 01-1.472 3.83 5.805 5.805 0 01-3.97 1.306zM19.975 20.41h-.164a5.447 5.447 0 01-.897.177c-.296.03-.586.107-.857.23a4.623 4.623 0 00-2.719 4.216 4.637 4.637 0 00-4.637-4.623 4.638 4.638 0 004.719-4.691 4.636 4.636 0 002.148 4.079 2.72 2.72 0 003.127-.163c2.149-1.646 2.992-5.222 1.85-8.376-2.013-5.562-9.614-7.465-14.346-4.08a13.108 13.108 0 00-3.657 16.698 15.788 15.788 0 0010.66 7.968C3.889 31.424-4.514 19.173 2.516 9.233A13.475 13.475 0 018.62 4.446a12.836 12.836 0 018.58-.258c5.235 1.713 8.702 7.207 6.459 12.523a6.092 6.092 0 01-3.835 3.685l.15.014z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#0FC1F7",
                        d: "M22.082 14.63a2.965 2.965 0 00-2.977 2.965 2.951 2.951 0 00-2.965-2.964 2.964 2.964 0 002.965-2.992 2.978 2.978 0 002.977 2.992z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#0FC1F7",
                        d: "M16.44 0A15.786 15.786 0 0127.1 7.968a13.108 13.108 0 01-3.604 16.712c-4.731 3.399-12.319 1.495-14.345-4.08-1.36-3.916.231-8.498 3.671-9.192a1.714 1.714 0 011.931 1.047c.094.224.14.465.136.707a1.904 1.904 0 011.904-1.903 1.904 1.904 0 01-1.904-1.904c-.002.422-.14.832-.394 1.17a1.658 1.658 0 01-1.36.666 5.82 5.82 0 00-5.153 3.902c-2.244 5.317 1.223 10.878 6.472 12.524 2.8.9 5.826.81 8.566-.259a13.34 13.34 0 006.051-4.745C36.101 12.673 27.711.422 16.385 0h.054zM45.688 28.337V12.66h-5.875V6.84h17.84v5.82h-5.846v15.678h-6.12zM74.038 20.247a8.323 8.323 0 01-2.474 6.091 9.64 9.64 0 01-12.863 0 8.784 8.784 0 010-12.237 9.6 9.6 0 0112.863 0 8.266 8.266 0 012.475 6.146zm-8.906 3.209a3.155 3.155 0 003.21-3.236 3.196 3.196 0 10-6.378 0 3.113 3.113 0 00.91 2.311 3.073 3.073 0 002.258.925zM86.344 11.748a7.248 7.248 0 015.643 2.448 8.54 8.54 0 012.217 6.024 8.702 8.702 0 01-2.217 6.05 7.167 7.167 0 01-5.616 2.475 6.445 6.445 0 01-4.324-1.51V35H76.31V12.156h5.643v1.197a6.554 6.554 0 014.392-1.605zM85.188 23.51a3.114 3.114 0 003.196-3.236 3.182 3.182 0 00-.898-2.312 3.318 3.318 0 00-4.582 0 3.318 3.318 0 000 4.596 3.058 3.058 0 002.284.952z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H391.867V35H0z"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/styles/variables/topcommercialcleanersVariables.module.scss
var topcommercialcleanersVariables_module = __webpack_require__(14192);
var topcommercialcleanersVariables_module_default = /*#__PURE__*/__webpack_require__.n(topcommercialcleanersVariables_module);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/topcommercialcleanersWrapper.tsx









const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function TopCommercialCleanersWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Commercial Cleaners",
                    domain: "TopCommercialCleaners.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Commercial Cleaners",
                    domain: "TopCommercialCleaners.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "top commercial cleaning companies",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCommercialCleanersLogo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        textColor: (topcommercialcleanersVariables_module_default()).grey
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 14192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"green":"#134981","hover":"#f1f8ff","orange":"#ff8a00","grey":"#777"};

/***/ })

}]);